import { Entity } from '@/modules/common/domain/entity'

export default class CompanyApply extends Entity {
}
